<template>
    <section>
        <div class="platform__capabilities__wrappers">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                        <h4 style="margin-top: 200px "  data-aos-duration="2000" data-aos="fade">Platform Capabilities</h4>
                        <div data-aos-duration="3000" data-aos="fade" class="title-capabilities">
                            Delivery services and customer expectations are rapidly changing. <br>
                            Leveraging different options as part of a multi-carrier delivery strategy is critical to
                            maintaining your competitive advantage:
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div  data-aos-duration="2000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img" src="../assets/images/platform-capabilities/Icon1.webp"
                                             alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Proprietary algorithms</span> Balance and optimize demand and supply,
                                            and manage scheduling and capacity constraints
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img" src="../assets/images/platform-capabilities/Tracking.webp"
                                             alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Transparency</span> A single interface providing real-time visibility,
                                            monitoring and tracking of the entire operation
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img"
                                             src="../assets/images/platform-capabilities/ICONACHIEVE.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Multi-Carrier  Decision Support System</span> a real-time expert
                                            system for intelligent delivery selection based on business and operational
                                            criteria
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img" src="../assets/images/platform-capabilities/Icon2.webp"
                                             alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Efficiently</span> provides the best personalized delivery option for
                                            customers in real-time
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img style="bottom: 5px" class="plat-img"
                                             src="../assets/images/platform-capabilities/ICONSPEEDY.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Vehicle and courier automation and excellent  customer experience</span>
                                            Vehicle and courier automation application supporting autonomous, connected
                                            vehicles and droids. excellent customer experience
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div  data-aos-duration="2000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img"
                                             src="../assets/images/platform-capabilities/Analytics.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Predictive and performance analytics</span>, Real-time ETA and SLA
                                            monitoring
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img" src="../assets/images/platform-capabilities/Icon3.webp"
                                             alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Simultaneously supports multiple delivery models and combinations</span>
                                            - Same day, next day, on-demand etc.
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img class="plat-img"
                                             src="../assets/images/platform-capabilities/ICONPROVIDE.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Load balancing</span> Balances supply and demand, including resolving
                                            peak-time issues
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class=" col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img  class="plat-img"
                                             src="../assets/images/platform-capabilities/icon4.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>Enables</span> management of a uniform delivery process and <span>customer experience</span>
                                        </div>
                                    </div>
                                </div>
                                <div  data-aos-duration="3000" data-aos="fade"  class="row">
                                    <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                        <img style="bottom: 5px" class="plat-img"
                                             src="../assets/images/platform-capabilities/icon5.webp" alt="..."/>
                                    </div>
                                    <div class="col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9">
                                        <div class="webp-title">
                                            <span>High-speed Integration backbone</span> Scalable Connectivity and
                                            Integration platform supporting Pub/Sub, Messaging, Micro Services (IoT) for
                                            future integration with AV, drones and robots
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {}
</script>
